// === product-search.widgets.js ===
((ns) => {
  // Helper function to scroll to the current refinements when a facet is used
  const scrollToFirstProduct = () => {
    const refinementsContainer = document.querySelector("#current-refinements");

    if (refinementsContainer) {
      // Add a small delay to ensure the DOM has updated
      // setTimeout(() => {
      //   refinementsContainer.scrollIntoView({ behavior: "smooth", block: "start" });
      // }, 100);
    }
  };

  // Initialize filter button functionality for search and collection pages
  const initializeFilterButtons = () => {
    // Function to attach event listener to a filter button
    const attachFilterButtonListener = (button) => {
      // Check if listener already attached to avoid duplicates
      if (button.hasAttribute("data-filter-listener-attached")) return;

      button.setAttribute("data-filter-listener-attached", "true");
      button.addEventListener("click", () => {
        // Find the drawer filter container
        const drawerFilter = document.querySelector(".collection-products-section__filter-drawer-container");

        if (drawerFilter) {
          drawerFilter.classList.add("collection-products-section__filter-drawer-container--open");
          document.body.style.overflow = "hidden";
        }
      });
    };

    // Find and initialize all existing filter buttons
    const filterButtons = document.querySelectorAll(".filter-sorting-btn");
    filterButtons.forEach(attachFilterButtonListener);

    // Set up MutationObserver to watch for new filter buttons
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node is a filter button
            if (node.classList && node.classList.contains("filter-sorting-btn")) {
              attachFilterButtonListener(node);
            }
            // Also check descendants
            const descendantButtons = node.querySelectorAll ? node.querySelectorAll(".filter-sorting-btn") : [];
            descendantButtons.forEach(attachFilterButtonListener);
          }
        });
      });
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Also handle close button and overlay clicks
    const closeDrawer = () => {
      const drawerFilter = document.querySelector(".collection-products-section__filter-drawer-container");
      if (drawerFilter) {
        drawerFilter.classList.remove("collection-products-section__filter-drawer-container--open");
        document.body.style.overflow = "";
      }
    };

    // Function to attach close handlers
    const attachCloseHandlers = () => {
      const closeButton = document.querySelector(".filter-drawer-header__close");
      const overlay = document.querySelector(".collection-products-section__filter-drawer-overlay");
      const footerButton = document.querySelector(".filter-drawer__footer-btn");

      if (closeButton && !closeButton.hasAttribute("data-close-listener-attached")) {
        closeButton.setAttribute("data-close-listener-attached", "true");
        closeButton.addEventListener("click", closeDrawer);
      }

      if (overlay && !overlay.hasAttribute("data-overlay-listener-attached")) {
        overlay.setAttribute("data-overlay-listener-attached", "true");
        overlay.addEventListener("click", closeDrawer);
      }

      if (footerButton && !footerButton.hasAttribute("data-close-listener-attached")) {
        footerButton.setAttribute("data-close-listener-attached", "true");
        footerButton.addEventListener("click", closeDrawer);
      }
    };

    // Attach close handlers initially
    attachCloseHandlers();

    // Also watch for dynamically added close buttons/overlays
    const closeObserver = new MutationObserver(() => {
      attachCloseHandlers();
    });

    closeObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  // --- renderRangeSlider ---
  const renderRangeSlider = (() => {
    // Store cache per container to handle multiple sliders
    const cacheByContainer = new WeakMap();

    return (renderOptions, isFirstRender) => {
      const { range, refine, widgetParams } = renderOptions;
      const { container } = widgetParams;

      // Get or create cache for this specific container
      const containerElem = typeof container === "string" ? document.querySelector(container) : container;
      if (!containerElem) return;

      let cache = cacheByContainer.get(containerElem);
      if (!cache) {
        cache = {
          _refs: {},
          min: range.min,
          max: range.max,
        };
        cacheByContainer.set(containerElem, cache);
      }

      // Update range values on every render
      cache.min = range.min;
      cache.max = range.max;

      // Find the other price range filter instance
      const allContainers = document.querySelectorAll(".filter-price");
      const otherContainer = Array.from(allContainers).find((cont) => cont !== containerElem);

      const createElem = (tag, classNames = "", attrs = {}) => {
        const el = document.createElement(tag);
        if (classNames) el.className = classNames;
        Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
        return el;
      };

      if (isFirstRender) {
        const wrapper = createElem("div", "filter-dropdown-item");

        const header = createElem("div", "filter-dropdown-item__header");
        const title = createElem("span", "highlighted-text filter-dropdown-item__title", { role: "button" });
        const span = createElem(
          "span",
          "text text--sm text--regular text--line-height-lg text--headline-font text--none-decoration",
          { style: "--text-color: var(--color--secondary)" },
        );
        span.textContent = window.searchTranslations?.filters?.price || "Preis";
        title.appendChild(span);

        // Create a temporary div to hold the SVG HTML
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = `<svg width="16" height="16" aria-hidden="false" aria-label="Dropdown arrow" class="icon filter-dropdown-item__icon" style="--icon-fill: none; --icon-stroke: var(--color--secondary);">
          <use xlink:href="#icon-arrow-filter"></use>
        </svg>`;
        const svg = tempDiv.firstChild;
        header.append(title, svg);

        const body = createElem("div", "filter-price filter-dropdown-item__body", {
          role: "group",
          "aria-label": "Price filter",
        });

        const inputsGroup = createElem("div", "filter-price-inputs", {
          role: "group",
          "aria-label": "Price range filter",
          "aria-live": "polite",
        });
        const minWrapper = createElem("div", "price-input filter-price-inputs__min", {
          style: `--currency: '${window.Shopify?.currency?.active === "CHF" ? "CHF" : "€"}'`,
        });
        const minTextInput = createElem("input", "price-input__input input", {
          type: "text",
          placeholder: String(range.min),
          "aria-labelledby": "price-input-label",
          value: String(range.min),
        });
        minWrapper.appendChild(minTextInput);

        const separator = createElem("div", "filter-price-inputs__seperator");

        const maxWrapper = createElem("div", "price-input filter-price-inputs__max", {
          style: `--currency: '${window.Shopify?.currency?.active === "CHF" ? "CHF" : "€"}'`,
        });
        const maxTextInput = createElem("input", "price-input__input input", {
          type: "text",
          placeholder: String(range.max),
          "aria-labelledby": "price-input-label",
          value: String(range.max),
        });
        maxWrapper.appendChild(maxTextInput);

        inputsGroup.append(minWrapper, separator, maxWrapper);
        body.append(inputsGroup);

        // Add second range slider
        const secondRangeSlider = createElem("filter-range", "", {
          role: "group",
          "aria-label": "Second price range filter",
        });

        const secondSliderContainer = createElem("div", "range-slider", {
          role: "group",
          "aria-label": "Second price range filter",
          "aria-description": "Use arrow keys to adjust the minimum and maximum price values",
        });

        const sliderContainer = createElem("div", "range-slider__container");

        // Visual elements for the second slider
        const valLeft = createElem("div", "range-slider__val-left", { style: "width: 0%;" });
        const valRight = createElem("div", "range-slider__val-right", { style: "width: 0%;" });
        const valRange = createElem("div", "range-slider__val-range", { style: "left: 0%; right: 0%;" });
        const handleLeft = createElem("span", "range-slider__handle range-slider__handle-left", { style: "left: 0%;" });
        const handleRight = createElem("span", "range-slider__handle range-slider__handle-right", {
          style: "left: 100%;",
        });

        sliderContainer.append(valLeft, valRight, valRange, handleLeft, handleRight);

        // Range inputs for the second slider
        const inputLeft = createElem("input", "range-slider__input-left", {
          "aria-label": "Minimum price",
          type: "range",
          tabindex: "0",
          max: "100",
          min: "0",
          step: "1",
        });

        const inputRight = createElem("input", "range-slider__input-right", {
          "aria-label": "Maximum price",
          type: "range",
          tabindex: "0",
          max: "100",
          min: "0",
          step: "1",
        });

        secondSliderContainer.append(sliderContainer, inputLeft, inputRight);
        secondRangeSlider.appendChild(secondSliderContainer);
        body.append(secondRangeSlider);

        // Add slider interaction logic
        const updateSliderVisuals = (targetContainer, leftPercent, rightPercent) => {
          const leftVal = targetContainer.querySelector(".range-slider__val-left");
          const rightVal = targetContainer.querySelector(".range-slider__val-right");
          const rangeVal = targetContainer.querySelector(".range-slider__val-range");
          const leftHandle = targetContainer.querySelector(".range-slider__handle-left");
          const rightHandle = targetContainer.querySelector(".range-slider__handle-right");

          if (leftVal) leftVal.style.width = `${leftPercent}%`;
          if (rightVal) rightVal.style.width = `${100 - rightPercent}%`;
          if (rangeVal) rangeVal.style.left = `${leftPercent}%`;
          if (rangeVal) rangeVal.style.right = `${100 - rightPercent}%`;
          if (leftHandle) leftHandle.style.left = `${leftPercent}%`;
          if (rightHandle) rightHandle.style.left = `${rightPercent}%`;
        };

        const updatePriceInputs = (leftPercent, rightPercent, isLeftHandle, shouldRefine = false) => {
          // Calculate prices based on percentages, using cached values for extremes
          if (isLeftHandle) {
            const leftPrice =
              leftPercent === 0 ? cache.min : Math.round(cache.min + ((cache.max - cache.min) * leftPercent) / 100);
            minTextInput.value = String(leftPrice);

            // Update other instance if it exists
            if (otherContainer) {
              const otherMinInput = otherContainer.querySelector(".filter-price-inputs__min input");
              if (otherMinInput) otherMinInput.value = String(leftPrice);
              updateSliderVisuals(otherContainer, leftPercent, rightPercent);
            }
          } else {
            const rightPrice =
              rightPercent === 100 ? cache.max : Math.round(cache.min + ((cache.max - cache.min) * rightPercent) / 100);
            maxTextInput.value = String(rightPrice);

            // Update other instance if it exists
            if (otherContainer) {
              const otherMaxInput = otherContainer.querySelector(".filter-price-inputs__max input");
              if (otherMaxInput) otherMaxInput.value = String(rightPrice);
              updateSliderVisuals(otherContainer, leftPercent, rightPercent);
            }
          }

          // Update current slider visuals
          updateSliderVisuals(containerElem, leftPercent, rightPercent);

          // Only trigger Algolia search if shouldRefine is true
          if (shouldRefine) {
            refine([Number(minTextInput.value), Number(maxTextInput.value)]);
            // Scroll to top of results after applying price filter
            scrollToFirstProduct();
          }
        };

        // Function to handle dragging of handles
        const initializeDragging = () => {
          let isDragging = false;
          let currentHandle = null;
          let sliderRect = null;
          let currentLeftPercent = 0;
          let currentRightPercent = 100;

          const getPercentage = (clientX) => {
            if (!sliderRect) {
              sliderRect = sliderContainer.getBoundingClientRect();
            }
            const percent = ((clientX - sliderRect.left) / sliderRect.width) * 100;
            return Math.min(Math.max(percent, 0), 100);
          };

          const updateSlider = (handle, percent) => {
            if (!handle || !handle.classList) return;

            const isLeft = handle.classList.contains("range-slider__handle-left");

            if (isLeft && percent < currentRightPercent) {
              currentLeftPercent = percent;
              // Update inputs but don't trigger search
              updatePriceInputs(currentLeftPercent, currentRightPercent, true, false);
            } else if (!isLeft && percent > currentLeftPercent) {
              currentRightPercent = percent;
              // Update inputs but don't trigger search
              updatePriceInputs(currentLeftPercent, currentRightPercent, false, false);
            }
          };

          const startDragging = (e, handle) => {
            isDragging = true;
            currentHandle = handle;
            sliderRect = sliderContainer.getBoundingClientRect();
            document.body.style.cursor = "grabbing";
            e.preventDefault();
          };

          const stopDragging = () => {
            if (isDragging) {
              isDragging = false;
              document.body.style.cursor = "";

              // Update price inputs and trigger Algolia search when dragging stops
              const isLeft = currentHandle.classList.contains("range-slider__handle-left");
              updatePriceInputs(currentLeftPercent, currentRightPercent, isLeft, true);
            }
            currentHandle = null;
            sliderRect = null;
          };

          const onMove = (clientX) => {
            if (!isDragging || !currentHandle) return;
            const percent = getPercentage(clientX);
            requestAnimationFrame(() => updateSlider(currentHandle, percent));
          };

          // Mouse events
          [handleLeft, handleRight].forEach((handle) => {
            handle.addEventListener("mousedown", (e) => startDragging(e, handle));
          });

          document.addEventListener("mousemove", (e) => onMove(e.clientX));
          document.addEventListener("mouseup", stopDragging);

          // Touch events
          [handleLeft, handleRight].forEach((handle) => {
            handle.addEventListener("touchstart", (e) => {
              startDragging(e, handle);
            });
          });

          document.addEventListener("touchmove", (e) => {
            const touch = e.touches[0];
            onMove(touch.clientX);
          });

          document.addEventListener("touchend", stopDragging);
          document.addEventListener("touchcancel", stopDragging);
        };

        // Initialize slider positions
        const initializeSliderPositions = () => {
          // Set initial handle positions to match current price input values
          handleLeft.style.left = "0%";
          valLeft.style.width = "0%";
          valRange.style.left = "0%";

          handleRight.style.left = "100%";
          valRight.style.width = "0%";
          valRange.style.right = "0%";

          // Set initial input values
          minTextInput.value = String(range.min);
          maxTextInput.value = String(range.max);
        };

        // Initialize everything on first render
        if (isFirstRender) {
          initializeSliderPositions();
          initializeDragging();
        }

        wrapper.append(header, body);
        containerElem.appendChild(wrapper);

        cache._refs = { minTextInput, maxTextInput, wrapper, header, body, svg };

        // Add toggle functionality to the header
        const dropdownItem = wrapper;
        const icon = svg;

        if (header && body && dropdownItem) {
          // Initially closed
          body.style.display = "none";
          dropdownItem.classList.add("filter-dropdown-item--closed");
          if (icon) {
            icon.style.transform = "rotate(-180deg)";
          }

          // Add click handler to toggle
          header.addEventListener("click", () => {
            const isOpen = body.style.display !== "none";

            if (isOpen) {
              // Close
              body.style.display = "none";
              dropdownItem.classList.add("filter-dropdown-item--closed");
              dropdownItem.classList.remove("filter-dropdown-item--open");
              if (icon) {
                icon.style.transform = "rotate(-180deg)";
                icon.style.transition = "transform 0.3s ease";
              }
            } else {
              // Open
              body.style.display = "";
              dropdownItem.classList.remove("filter-dropdown-item--closed");
              dropdownItem.classList.add("filter-dropdown-item--open");
              if (icon) {
                icon.style.transform = "rotate(0deg)";
                icon.style.transition = "transform 0.3s ease";
              }
            }
          });

          // Add cursor pointer to header
          header.style.cursor = "pointer";
        }

        minTextInput.addEventListener("change", (e) => {
          const minVal = Number(e.currentTarget.value);
          const maxVal = Number(cache._refs.maxTextInput.value);
          if (!Number.isNaN(minVal) && minVal <= maxVal) {
            refine([minVal, maxVal]);
            scrollToFirstProduct();
          }
        });

        maxTextInput.addEventListener("change", (e) => {
          const maxVal = Number(e.currentTarget.value);
          const minVal = Number(cache._refs.minTextInput.value);
          if (!Number.isNaN(maxVal) && maxVal >= minVal) {
            refine([minVal, maxVal]);
            scrollToFirstProduct();
          }
        });
      }

      const [refinedMin, refinedMax] = renderOptions.start;
      const { minTextInput, maxTextInput } = cache._refs;

      if (minTextInput && maxTextInput) {
        if (document.activeElement !== minTextInput) {
          const val = Number.isFinite(refinedMin) ? refinedMin : range.min;
          minTextInput.value = String(val);
        }

        if (document.activeElement !== maxTextInput) {
          const val = Number.isFinite(refinedMax) ? refinedMax : range.max;
          maxTextInput.value = String(val);
        }
      }
    };
  })();

  // --- renderSortBy ---
  const renderSortBy = (() => {
    const cache = { _refs: {} };

    const createElem = (tag, classNames = "", attrs = {}) => {
      const el = document.createElement(tag);
      if (classNames) el.className = classNames;
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
      return el;
    };

    const createIcon = (iconId, { width = 16, height = 16 } = {}) => {
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("width", width);
      svg.setAttribute("height", height);
      svg.setAttribute("aria-hidden", "true");
      svg.classList.add("icon");
      svg.style.setProperty("--icon-fill", "none");
      svg.style.setProperty("--icon-stroke", "var(--color--secondary)");

      const use = document.createElementNS("http://www.w3.org/2000/svg", "use");
      use.setAttribute("href", `#${iconId}`);
      svg.appendChild(use);

      return svg;
    };

    return (renderOptions, isFirstRender) => {
      const { options, refine, currentRefinement, widgetParams } = renderOptions;
      const { container } = widgetParams;

      // Early return if container is not provided
      if (!container) {
        // SortBy widget: container is required
        return;
      }

      const containerElem = typeof container === "string" ? document.querySelector(container) : container;

      // Early return if container element is not found
      if (!containerElem) {
        // SortBy widget: container element not found
        return;
      }

      // Check if this is for mobile drawer
      const isMobileDrawer = container === "#sorting-mobile";

      if (isMobileDrawer) {
        // Mobile drawer implementation
        if (isFirstRender) {
          const wrapper = createElem("filter-dropdown-item", "filter-dropdown-item filter-dropdown-item__sorting", {
            id: "SortingDropdown-mobile",
          });

          const header = createElem("div", "filter-dropdown-item__header");
          const title = createElem("span", "highlighted-text filter-dropdown-item__title", { role: "button" });

          const labelSpan = createElem(
            "span",
            "text text--sm text--regular text--line-height-lg text--headline-font text--none-decoration",
            { style: "--text-color: var(--color--secondary)" },
          );
          labelSpan.textContent = window.searchTranslations?.filters?.sortBy || "Sortieren nach: ";

          const valueSpan = createElem(
            "span",
            "text text--sm text--bold text--line-height-lg text--headline-font text--none-decoration text--highlighted js-filter-drawer-sort-header",
            { "aria-marked": "true", role: "mark" },
          );
          valueSpan.textContent = window.searchTranslations?.sort?.recommended || "Empfohlen";

          title.append(labelSpan, valueSpan);

          const arrowIcon = createIcon("icon-arrow-filter");
          arrowIcon.classList.add("filter-dropdown-item__icon");
          header.append(title, arrowIcon);

          const fieldset = createElem("fieldset", "filter-checkboxes filter-dropdown-item__body", {
            "aria-label": "Filter options",
            role: "group",
          });
          fieldset.style.display = "none"; // Initially hidden

          wrapper.append(header, fieldset);
          containerElem.appendChild(wrapper);

          cache._refs.mobileValueSpan = valueSpan;
          cache._refs.mobileFieldset = fieldset;
          cache._refs.mobileHeader = header;

          // Toggle dropdown on header click
          header.addEventListener("click", () => {
            const isOpen = fieldset.style.display !== "none";
            fieldset.style.display = isOpen ? "none" : "flex";
            wrapper.classList.toggle("filter-dropdown-item--open", !isOpen);
          });
        }

        // Update mobile drawer content
        const { mobileValueSpan, mobileFieldset } = cache._refs;
        const currentItem = options.find((item) => item.value === currentRefinement);
        if (currentItem && mobileValueSpan) {
          mobileValueSpan.textContent = currentItem.label;
        }

        if (mobileFieldset) {
          mobileFieldset.innerHTML = "";
          options.forEach((item) => {
            const label = createElem("label", "field field--row filter-checkboxes__input");
            const input = createElem("input", "input js-filter-radio", {
              type: "radio",
              name: "sort_by_mobile",
              "data-filter-to-add": item.value,
            });

            if (item.value === currentRefinement) {
              input.checked = true;
            }

            const span = createElem("span", "field__label");
            span.textContent = item.label;

            label.append(input, span);
            mobileFieldset.appendChild(label);

            input.addEventListener("change", () => {
              if (input.checked) {
                refine(item.value);
                scrollToFirstProduct();
                mobileFieldset.style.display = "none";
                cache._refs.mobileHeader.parentElement.classList.remove("filter-dropdown-item--open");
              }
            });
          });
        }
      } else {
        // Desktop implementation (existing code)
        if (isFirstRender) {
          const wrapper = createElem("div", "sorting-selector__container js-sorting-selector");
          const header = createElem("button", "sorting-selector__header", {
            "aria-label": "Select sorting option",
            "aria-controls": "sorting-options",
            "aria-expanded": "false",
          });

          const valueDiv = createElem("div", "sorting-selector__value");
          const span = createElem("span", "text text--x-sm text--regular text--body-font text--none-decoration", {
            style: "--text-color: var(--color--secondary)",
          });
          span.textContent = window.searchTranslations?.sort?.recommended || "Empfohlen";
          valueDiv.appendChild(span);

          const arrowIcon = createIcon("icon-arrow-point-down");
          header.append(valueDiv, arrowIcon);

          const optionsList = createElem("ul", "sorting-selector__options is-hidden", {
            id: "sorting-options",
            role: "listbox",
          });

          wrapper.append(header, optionsList);
          containerElem.appendChild(wrapper);

          cache._refs = { header, valueSpan: span, optionsList };

          header.addEventListener("click", () => {
            optionsList.classList.toggle("is-hidden");
            header.setAttribute("aria-expanded", optionsList.classList.contains("is-hidden") ? "false" : "true");
          });

          document.addEventListener("click", (event) => {
            if (!wrapper.contains(event.target)) {
              optionsList.classList.add("is-hidden");
              header.setAttribute("aria-expanded", "false");
            }
          });
        }

        const { header, valueSpan, optionsList } = cache._refs;
        const currentItem = options.find((item) => item.value === currentRefinement);
        if (currentItem) {
          valueSpan.textContent = currentItem.label;
        }

        optionsList.innerHTML = "";
        options.forEach((item) => {
          const isSelected = item.value === currentRefinement;
          const li = createElem(
            "li",
            `sorting-selector__option${isSelected ? " sorting-selector__option--selected" : ""}`,
            { role: "option", "aria-selected": String(isSelected) },
          );

          const valDiv = createElem("div", "sorting-selector__value");
          const span = createElem("span", "text text--x-sm text--regular text--body-font text--none-decoration", {
            style: "--text-color: var(--color--secondary)",
          });
          span.textContent = item.label;
          valDiv.appendChild(span);
          li.append(valDiv);

          if (isSelected) {
            const checkIcon = createIcon("icon-checkmark", { width: 16, height: 16 });
            checkIcon.classList.add("sorting-selector__icon");
            li.append(checkIcon);
          }

          li.addEventListener("click", () => {
            refine(item.value);
            scrollToFirstProduct();
            optionsList.classList.add("is-hidden");
            header.setAttribute("aria-expanded", "false");
          });

          optionsList.appendChild(li);
        });
      }
    };
  })();

  // --- createRefinementListWithHeader ---
  const createRefinementListWithHeader = function ({ attribute, container, label }) {
    const { connectRefinementList } = window.instantsearch.connectors;

    // Store search state per attribute
    const searchState = {};

    // Custom render function that preserves search state
    const renderRefinementList = (renderOptions, isFirstRender) => {
      const { items, refine, searchForItems, isFromSearch, isShowingMore, toggleShowMore } = renderOptions;

      const containerElem = typeof container === "string" ? document.querySelector(container) : container;

      if (!containerElem) return;

      // Initialize container on first render
      if (isFirstRender) {
        containerElem.innerHTML = `
          <div class="filter-dropdown-item">
            <div class="filter-dropdown-item__header">
              <span class="highlighted-text filter-dropdown-item__title" role="button">
                <span class="text text--sm text--regular text--line-height-lg text--headline-font text--none-decoration" style="--text-color: var(--color--secondary);">
                  ${label}
                </span>
              </span>
              <svg width="16" height="16" aria-hidden="false" aria-label="Dropdown arrow" class="icon filter-dropdown-item__icon" style="--icon-fill: none; --icon-stroke: var(--color--secondary);">
                <use xlink:href="#icon-arrow-filter"></use>
              </svg>
            </div>
            <div class="filter-checkboxes filter-dropdown-item__body">
              ${
                items.length > 15
                  ? `
                <div class="filter-checkboxes__search">
                  <div class="filter-checkboxes__search-wrapper">
                    <input type="search" class="input filter-checkboxes__search-input js-filter-search" placeholder="${window.searchTranslations?.filters?.searchPlaceholder || "Suchen..."}" />
                    <button type="submit" class="filter-checkboxes__search-icon js-search-icon">
                      <svg class="icon icon-search" width="16" height="16">
                        <use class="js-search-icon-search" xlink:href="#icon-search"></use>
                      </svg>
                    </button>
                  </div>
                </div>
              `
                  : ""
              }
              <div class="filter-checkboxes__list"></div>
              ${
                items.length > 5
                  ? `
                <button type="button" class="button button--text filter-checkboxes__toggle-btn js-filter-checkboxes__toggle-btn">
                  <span class="button__text js-filter-checkboxes__toggle-text">${window.searchTranslations?.filters?.showAll || "Alle anzeigen"}</span>
                </button>
              `
                  : ""
              }
            </div>
          </div>
        `;

        // Add toggle functionality to the header
        const header = containerElem.querySelector(".filter-dropdown-item__header");
        const body = containerElem.querySelector(".filter-dropdown-item__body");
        const dropdownItem = containerElem.querySelector(".filter-dropdown-item");
        const icon = containerElem.querySelector(".filter-dropdown-item__icon");

        if (header && body && dropdownItem) {
          // Initially closed
          body.style.display = "none";
          dropdownItem.classList.add("filter-dropdown-item--closed");
          if (icon) {
            icon.style.transform = "rotate(-180deg)";
          }

          // Add click handler to toggle
          header.addEventListener("click", () => {
            const isOpen = body.style.display !== "none";

            if (isOpen) {
              // Close
              body.style.display = "none";
              dropdownItem.classList.add("filter-dropdown-item--closed");
              dropdownItem.classList.remove("filter-dropdown-item--open");
              if (icon) {
                icon.style.transform = "rotate(-180deg)";
                icon.style.transition = "transform 0.3s ease";
              }
            } else {
              // Open
              body.style.display = "";
              dropdownItem.classList.remove("filter-dropdown-item--closed");
              dropdownItem.classList.add("filter-dropdown-item--open");
              if (icon) {
                icon.style.transform = "rotate(0deg)";
                icon.style.transition = "transform 0.3s ease";
              }
            }
          });

          // Add cursor pointer to header
          header.style.cursor = "pointer";
        }

        // Set up search input handler only if search exists
        const searchInput = containerElem.querySelector(".js-filter-search");
        if (searchInput) {
          searchInput.addEventListener("input", (e) => {
            const query = e.target.value;
            searchState[attribute] = query;
            searchForItems(query);
          });
        }
      }

      // Update the list
      const listContainer = containerElem.querySelector(".filter-checkboxes__list");
      const searchInput = containerElem.querySelector(".js-filter-search");
      const showMoreButton = containerElem.querySelector(".js-filter-checkboxes__toggle-btn");
      const dropdownItem = containerElem.querySelector(".filter-dropdown-item");

      if (listContainer) {
        // Determine items to show
        const limit = isShowingMore ? 50 : 5;
        const visibleItems = items.slice(0, limit);
        // Add empty state class to the topmost element only when there's no search query
        dropdownItem.classList.toggle(
          "filter-dropdown-item--empty",
          visibleItems.length === 0 && !searchState[attribute],
        );

        listContainer.innerHTML =
          visibleItems.length > 0
            ? visibleItems
                .map(
                  (item) => `
          <label class="field field--row filter-checkboxes__input">
            <input class="input ${item.isRefined ? "input--checked" : ""}" type="checkbox" value="${item.value}" ${item.isRefined ? "checked" : ""} />
            <span class="field__label">${item.label}</span>
            <span class="filter-checkboxes__count-option text--secondary text--copy-medium-default">${item.count}</span>
          </label>
        `,
                )
                .join("")
            : "";

        // Add click handlers for checkboxes
        listContainer.querySelectorAll('input[type="checkbox"]').forEach((checkbox, index) => {
          checkbox.addEventListener("change", () => {
            refine(visibleItems[index].value);
            scrollToFirstProduct();
          });
        });
      }

      // Rest of the code remains unchanged...
      // Restore search state if needed
      if (searchInput && !isFromSearch && searchState[attribute]) {
        searchInput.value = searchState[attribute];
        // Re-apply the search
        searchForItems(searchState[attribute]);
      }

      // Update show more button
      if (showMoreButton) {
        const showMoreText = showMoreButton.querySelector(".js-filter-checkboxes__toggle-text");
        if (showMoreText) {
          showMoreText.textContent = isShowingMore
            ? window.searchTranslations?.filters?.showLess || "Weniger anzeigen"
            : window.searchTranslations?.filters?.showAll || "Alle anzeigen";
        }
        // Always show button if there are more than 5 items
        showMoreButton.style.display = items.length > 5 ? "" : "none";

        // Remove old event listeners and add new one
        const newButton = showMoreButton.cloneNode(true);
        showMoreButton.parentNode.replaceChild(newButton, showMoreButton);
        newButton.addEventListener("click", () => {
          toggleShowMore();
        });
      }

      // Handle search box visibility dynamically
      const searchContainer = containerElem.querySelector(".filter-checkboxes__search");

      // If we have more than 15 items but no search box, create it
      if ((items.length > 15 || searchState[attribute]) && !searchContainer) {
        const bodyElem = containerElem.querySelector(".filter-checkboxes");
        if (bodyElem) {
          const searchHTML = `
            <div class="filter-checkboxes__search">
              <div class="filter-checkboxes__search-wrapper">
                <input type="search" class="input filter-checkboxes__search-input js-filter-search" placeholder="${window.searchTranslations?.filters?.searchPlaceholder || "Suchen..."}" />
                <button type="submit" class="filter-checkboxes__search-icon js-search-icon">
                  <svg class="icon icon-search" width="16" height="16">
                    <use class="js-search-icon-search" xlink:href="#icon-search"></use>
                  </svg>
                </button>
              </div>
            </div>
          `;
          bodyElem.insertAdjacentHTML("afterbegin", searchHTML);

          // Set up the event handler for the newly created search input
          const newSearchInput = bodyElem.querySelector(".js-filter-search");
          if (newSearchInput) {
            newSearchInput.addEventListener("input", (e) => {
              const query = e.target.value;
              searchState[attribute] = query;
              searchForItems(query);
            });

            // Restore search state if it exists
            if (searchState[attribute]) {
              newSearchInput.value = searchState[attribute];
              searchForItems(searchState[attribute]);
            }
          }
        }
      }
      // If we have 15 or fewer items and no active search query, hide the search box
      else if (items.length <= 15 && !searchState[attribute] && searchContainer) {
        searchContainer.style.display = "none";
      }
      // If we have more than 15 items OR an active search query, show the search box
      else if ((items.length > 15 || searchState[attribute]) && searchContainer) {
        searchContainer.style.display = "";
      }

      // Handle show more button visibility
      if (!showMoreButton && items.length > 5) {
        const bodyElem = containerElem.querySelector(".filter-checkboxes");
        if (bodyElem) {
          const buttonHTML = `
            <button type="button" class="button button--text filter-checkboxes__toggle-btn js-filter-checkboxes__toggle-btn">
              <span class="button__text js-filter-checkboxes__toggle-text">${isShowingMore ? window.searchTranslations?.filters?.showLess || "Weniger anzeigen" : window.searchTranslations?.filters?.showAll || "Alle anzeigen"}</span>
            </button>
          `;
          bodyElem.insertAdjacentHTML("beforeend", buttonHTML);

          const newShowMoreButton = bodyElem.querySelector(".js-filter-checkboxes__toggle-btn");
          if (newShowMoreButton) {
            newShowMoreButton.addEventListener("click", () => {
              toggleShowMore();
            });
          }
        }
      }
    };

    // Create the custom widget
    const customRefinementList = connectRefinementList(renderRefinementList);

    return customRefinementList({
      container,
      attribute,
      limit: 16,
      showMore: true,
      showMoreLimit: 50,
      searchable: true,
      searchablePlaceholder: window.searchTranslations?.filters?.searchPlaceholder || "Suchen...",
    });
  };

  // --- createGroupedNumericRefinementList ---
  const createGroupedNumericRefinementList = function ({ attribute, container, label }) {
    const { connectRefinementList } = window.instantsearch.connectors;

    // Helper function to generate 100s ranges dynamically based on data
    const generateHundredsRanges = (items) => {
      const numericValues = items
        .map((item) => {
          // Convert string with separator to number (e.g. "1.738" -> 1738)
          const cleanValue = item.value.replace(/\./g, "");
          return Number(cleanValue);
        })
        .filter((val) => !Number.isNaN(val));

      if (numericValues.length === 0) return [];

      const minValue = Math.min(...numericValues);
      const maxValue = Math.max(...numericValues);

      // Start from the floor of min value to nearest 100
      const startRange = Math.floor(minValue / 100) * 100;
      // End at the ceiling of max value to nearest 100
      const endRange = Math.ceil(maxValue / 100) * 100;

      const ranges = [];
      for (let i = startRange; i <= endRange; i += 100) {
        const rangeMin = i;
        const rangeMax = i + 99;
        ranges.push({
          label: `${rangeMin}-${rangeMax}`,
          min: rangeMin,
          max: rangeMax,
        });
      }

      return ranges;
    };

    // Helper function to find which range a numeric value belongs to
    const findRange = (value, rangeList) => {
      // Convert string with separator to number (e.g. "1.738" -> 1738)
      const cleanValue = value.replace(/\./g, "");
      const numValue = Number(cleanValue);
      if (Number.isNaN(numValue)) return null;

      return rangeList.find((range) => numValue >= range.min && numValue <= range.max);
    };

    // Rest of the code remains the same...
    const groupItemsByRange = (items) => {
      const ranges = generateHundredsRanges(items);
      const groups = new Map();

      // Initialize all ranges
      ranges.forEach((range) => {
        groups.set(range.label, {
          label: range.label,
          range,
          items: [],
          count: 0,
          isRefined: false,
          value: range.label, // Add value for refinement
        });
      });

      // Group items
      items.forEach((item) => {
        const range = findRange(item.value, ranges);
        if (range) {
          const group = groups.get(range.label);
          group.items.push(item);
          group.count += item.count;
          if (item.isRefined) {
            group.isRefined = true;
          }
        }
      });

      // Convert to array and filter out empty groups
      return Array.from(groups.values()).filter((group) => group.count > 0);
    };

    // Custom render function
    const renderGroupedRefinementList = (renderOptions, isFirstRender) => {
      const { items, refine, isShowingMore, toggleShowMore } = renderOptions;

      const containerElem = typeof container === "string" ? document.querySelector(container) : container;

      if (!containerElem) return;

      // Group the items
      const groupedItems = groupItemsByRange(items);

      // Initialize container on first render
      if (isFirstRender) {
        containerElem.innerHTML = `
          <div class="filter-dropdown-item">
            <div class="filter-dropdown-item__header">
              <span class="highlighted-text filter-dropdown-item__title" role="button">
                <span class="text text--sm text--regular text--line-height-lg text--headline-font text--none-decoration" style="--text-color: var(--color--secondary);">
                  ${label}
                </span>
              </span>
              <svg width="16" height="16" aria-hidden="false" aria-label="Dropdown arrow" class="icon filter-dropdown-item__icon" style="--icon-fill: none; --icon-stroke: var(--color--secondary);">
                <use xlink:href="#icon-arrow-filter"></use>
              </svg>
            </div>
            <div class="filter-checkboxes filter-dropdown-item__body">
              <div class="filter-checkboxes__list"></div>
              ${
                groupedItems.length > 5
                  ? `
                <button type="button" class="button button--text filter-checkboxes__toggle-btn js-filter-checkboxes__toggle-btn">
                  <span class="button__text js-filter-checkboxes__toggle-text">${window.searchTranslations?.filters?.showAll || "Alle anzeigen"}</span>
                </button>
              `
                  : ""
              }
            </div>
          </div>
        `;

        // Add toggle functionality to the header
        const header = containerElem.querySelector(".filter-dropdown-item__header");
        const body = containerElem.querySelector(".filter-dropdown-item__body");
        const dropdownItem = containerElem.querySelector(".filter-dropdown-item");
        const icon = containerElem.querySelector(".filter-dropdown-item__icon");

        if (header && body && dropdownItem) {
          // Initially closed
          body.style.display = "none";
          dropdownItem.classList.add("filter-dropdown-item--closed");
          if (icon) {
            icon.style.transform = "rotate(-180deg)";
          }

          // Add click handler to toggle
          header.addEventListener("click", () => {
            const isOpen = body.style.display !== "none";

            if (isOpen) {
              // Close
              body.style.display = "none";
              dropdownItem.classList.add("filter-dropdown-item--closed");
              dropdownItem.classList.remove("filter-dropdown-item--open");
              if (icon) {
                icon.style.transform = "rotate(-180deg)";
                icon.style.transition = "transform 0.3s ease";
              }
            } else {
              // Open
              body.style.display = "";
              dropdownItem.classList.remove("filter-dropdown-item--closed");
              dropdownItem.classList.add("filter-dropdown-item--open");
              if (icon) {
                icon.style.transform = "rotate(0deg)";
                icon.style.transition = "transform 0.3s ease";
              }
            }
          });

          // Add cursor pointer to header
          header.style.cursor = "pointer";
        }
      }

      // Update the list
      const listContainer = containerElem.querySelector(".filter-checkboxes__list");
      const showMoreButton = containerElem.querySelector(".js-filter-checkboxes__toggle-btn");
      const dropdownItem = containerElem.querySelector(".filter-dropdown-item");

      if (listContainer) {
        // Determine items to show
        const limit = isShowingMore ? 50 : 5;
        const visibleGroups = groupedItems.slice(0, limit);

        // Add empty state class
        dropdownItem.classList.toggle("filter-dropdown-item--empty", visibleGroups.length === 0);

        // Create group elements - using the same layout as regular refinement list
        listContainer.innerHTML =
          visibleGroups.length > 0
            ? visibleGroups
                .map(
                  (group) => `
          <label class="field field--row filter-checkboxes__input">
            <input class="input ${group.isRefined ? "input--checked" : ""}" type="checkbox" value="${group.label}" ${group.isRefined ? "checked" : ""} data-group-range="true" />
            <span class="field__label">${group.label}</span>
            <span class="filter-checkboxes__count-option text--secondary text--copy-medium-default">${group.count}</span>
          </label>
        `,
                )
                .join("")
            : "";

        // Add click handlers for checkboxes
        listContainer.querySelectorAll('input[type="checkbox"]').forEach((checkbox, index) => {
          checkbox.addEventListener("change", () => {
            const group = visibleGroups[index];
            // When a group is selected, refine all items in that group
            group.items.forEach((item) => {
              if (checkbox.checked && !item.isRefined) {
                refine(item.value);
              } else if (!checkbox.checked && item.isRefined) {
                refine(item.value);
              }
            });
            scrollToFirstProduct();
          });
        });
      }

      // Update show more button
      if (showMoreButton) {
        const showMoreText = showMoreButton.querySelector(".js-filter-checkboxes__toggle-text");
        if (showMoreText) {
          showMoreText.textContent = isShowingMore
            ? window.searchTranslations?.filters?.showLess || "Weniger anzeigen"
            : window.searchTranslations?.filters?.showAll || "Alle anzeigen";
        }
        // Always show button if there are more than 5 items
        showMoreButton.style.display = groupedItems.length > 5 ? "" : "none";

        // Remove old event listeners and add new one
        const newButton = showMoreButton.cloneNode(true);
        showMoreButton.parentNode.replaceChild(newButton, showMoreButton);
        newButton.addEventListener("click", () => {
          toggleShowMore();
        });
      }

      // Handle show more button visibility
      if (!showMoreButton && groupedItems.length > 5) {
        const bodyElem = containerElem.querySelector(".filter-checkboxes");
        if (bodyElem) {
          const buttonHTML = `
            <button type="button" class="button button--text filter-checkboxes__toggle-btn js-filter-checkboxes__toggle-btn">
              <span class="button__text js-filter-checkboxes__toggle-text">${isShowingMore ? window.searchTranslations?.filters?.showLess || "Weniger anzeigen" : window.searchTranslations?.filters?.showAll || "Alle anzeigen"}</span>
            </button>
          `;
          bodyElem.insertAdjacentHTML("beforeend", buttonHTML);

          const newShowMoreButton = bodyElem.querySelector(".js-filter-checkboxes__toggle-btn");
          if (newShowMoreButton) {
            newShowMoreButton.addEventListener("click", () => {
              toggleShowMore();
            });
          }
        }
      }
    };

    // Create the custom widget
    const customRefinementList = connectRefinementList(renderGroupedRefinementList);

    return customRefinementList({
      container,
      attribute,
      limit: 1000, // High limit to get all values for grouping
      showMore: true,
      showMoreLimit: 2000,
      searchable: false, // Disable search for grouped view
    });
  };

  // --- createExpressTagRefinement ---
  const createExpressTagRefinement = function ({ attribute, container, label }) {
    const { connectRefinementList } = window.instantsearch.connectors;

    // Custom render function for express tag
    const renderExpressTag = (renderOptions, isFirstRender) => {
      const { items, refine } = renderOptions;

      const containerElem = typeof container === "string" ? document.querySelector(container) : container;

      if (!containerElem) return;

      // Filter to only show items with value "1" and transform the label
      const filteredItems = items
        .filter((item) => item.value === "1")
        .map((item) => ({
          ...item,
          label: window.searchTranslations?.filters?.yes || "Ja",
        }));

      // Initialize container on first render
      if (isFirstRender) {
        containerElem.innerHTML = `
          <div class="filter-dropdown-item">
            <div class="filter-dropdown-item__header">
              <span class="highlighted-text filter-dropdown-item__title" role="button">
                <span class="text text--sm text--regular text--line-height-lg text--headline-font text--none-decoration" style="--text-color: var(--color--secondary);">
                  ${label}
                </span>
              </span>
              <svg width="16" height="16" aria-hidden="false" aria-label="Dropdown arrow" class="icon filter-dropdown-item__icon" style="--icon-fill: none; --icon-stroke: var(--color--secondary);">
                <use xlink:href="#icon-arrow-filter"></use>
              </svg>
            </div>
            <div class="filter-checkboxes filter-dropdown-item__body">
              <div class="filter-checkboxes__list"></div>
            </div>
          </div>
        `;

        // Add toggle functionality to the header
        const header = containerElem.querySelector(".filter-dropdown-item__header");
        const body = containerElem.querySelector(".filter-dropdown-item__body");
        const dropdownItem = containerElem.querySelector(".filter-dropdown-item");
        const icon = containerElem.querySelector(".filter-dropdown-item__icon");

        if (header && body && dropdownItem) {
          // Initially closed
          body.style.display = "none";
          dropdownItem.classList.add("filter-dropdown-item--closed");
          if (icon) {
            icon.style.transform = "rotate(-180deg)";
          }

          // Add click handler to toggle
          header.addEventListener("click", () => {
            const isOpen = body.style.display !== "none";

            if (isOpen) {
              // Close
              body.style.display = "none";
              dropdownItem.classList.add("filter-dropdown-item--closed");
              dropdownItem.classList.remove("filter-dropdown-item--open");
              if (icon) {
                icon.style.transform = "rotate(-180deg)";
                icon.style.transition = "transform 0.3s ease";
              }
            } else {
              // Open
              body.style.display = "";
              dropdownItem.classList.remove("filter-dropdown-item--closed");
              dropdownItem.classList.add("filter-dropdown-item--open");
              if (icon) {
                icon.style.transform = "rotate(0deg)";
                icon.style.transition = "transform 0.3s ease";
              }
            }
          });

          // Add cursor pointer to header
          header.style.cursor = "pointer";
        }
      }

      // Update the list
      const listContainer = containerElem.querySelector(".filter-checkboxes__list");

      if (listContainer) {
        // Hide the entire facet if there are no items with value "1"
        if (filteredItems.length === 0) {
          containerElem.style.display = "none";
          return;
        }
        containerElem.style.display = "";

        listContainer.innerHTML = filteredItems
          .map(
            (item) => `
          <label class="field field--row filter-checkboxes__input">
            <input class="input ${item.isRefined ? "input--checked" : ""}" type="checkbox" value="${item.value}" ${item.isRefined ? "checked" : ""} />
            <span class="field__label">${item.label}</span>
            <span class="filter-checkboxes__count-option text--secondary text--copy-medium-default">${item.count}</span>
          </label>
        `,
          )
          .join("");

        // Add click handlers for checkboxes
        listContainer.querySelectorAll('input[type="checkbox"]').forEach((checkbox, index) => {
          checkbox.addEventListener("change", () => {
            refine(filteredItems[index].value);
            scrollToFirstProduct();
          });
        });
      }
    };

    // Create the custom widget
    const customRefinementList = connectRefinementList(renderExpressTag);

    return customRefinementList({
      container,
      attribute,
      limit: 10,
    });
  };
  // Helper function to clean category values
  const cleanCategoryValue = (value) =>
    // Remove the JSON array syntax and quotes
    value.replace(/^\["/, "").replace(/"\]$/, "");
  // ─── render function you pass to connectHierarchicalMenu ──────────────────
  let isHierarchicalMenuFirstElementClicked = false;
  let hasLoggedInitialPaths = false;
  // isInitializing flag removed - was not being used

  // Helper function to build hierarchical structure
  const buildHierarchy = (items) => {
    const hierarchy = {};

    // First pass: Create all nodes
    items.forEach((item) => {
      const path = cleanCategoryValue(item.value);
      const segments = path.split("/");
      let currentLevel = hierarchy;
      let currentPath = "";

      segments.forEach((segment, index) => {
        currentPath = currentPath ? `${currentPath}/${segment}` : segment;
        if (!currentLevel[segment]) {
          currentLevel[segment] = {
            path: currentPath,
            count: 0,
            children: {},
            isRefined: false,
            level: index,
            value: item.value,
          };
        }
        // Update count only if this is the final segment
        if (index === segments.length - 1) {
          currentLevel[segment].count = item.count;
          currentLevel[segment].isRefined = item.isRefined;
        }
        currentLevel = currentLevel[segment].children;
      });
    });

    // Second pass: Calculate parent counts and check if has children
    const calculateCounts = (node) => {
      let totalCount = node.count || 0;
      const childrenKeys = Object.keys(node.children);

      childrenKeys.forEach((key) => {
        totalCount += calculateCounts(node.children[key]);
      });
      Object.assign(node, {
        count: totalCount,
        hasChildren: childrenKeys.length > 0,
      });
      return totalCount;
    };

    Object.values(hierarchy).forEach((node) => calculateCounts(node));

    return hierarchy;
  };

  // Add this helper function at the top level
  const getAllChildPaths = (items, parentPath) =>
    items.filter((item) => {
      const itemPath = cleanCategoryValue(item.value);
      return itemPath === parentPath || itemPath.startsWith(`${parentPath}/`);
    });

  // Add this helper function to check if a node has any refined children
  // const hasRefinedChildren = (node, items) => {
  //   const nodePath = node.path;
  //   return items.some(item => {
  //     const itemPath = cleanCategoryValue(item.value);
  //     return item.isRefined && (itemPath.startsWith(`${nodePath  }/`) || itemPath === nodePath);
  //   });
  // };

  // Add this helper function to get parent paths
  // const getParentPaths = (path) => {
  //   const segments = path.split('/');
  //   const parents = [];
  //   let currentPath = '';
  //
  //   for (let i = 0; i < segments.length - 1; i++) {
  //     currentPath = currentPath ? `${currentPath}/${segments[i]}` : segments[i];
  //     parents.push(currentPath);
  //   }
  //
  //   return parents;
  // };

  // Add this helper function to manage expanded state
  const createExpandedStateManager = () => {
    const expandedPaths = new Set();
    const expandedLevels = new Map(); // Track expanded items per level
    const directlySelectedPaths = new Set(); // Track paths that were directly clicked

    return {
      isExpanded: (path) => expandedPaths.has(path),
      isDirectlySelected: (path) => directlySelectedPaths.has(path),
      allPaths: () => Array.from(expandedPaths),
      allLevels: () => Array.from(expandedLevels.keys()),
      allDirectlySelectedPaths: () => Array.from(directlySelectedPaths),
      expandPath: (path, level) => {
        // If we have a different item expanded at this level, collapse it
        if (expandedLevels.has(level)) {
          const previousPath = expandedLevels.get(level);
          if (previousPath !== path) {
            expandedPaths.delete(previousPath);
          }
        }
        expandedPaths.add(path);
        expandedLevels.set(level, path);
      },

      collapsePath: (path, level) => {
        expandedPaths.delete(path);
        directlySelectedPaths.delete(path);
        if (expandedLevels.get(level) === path) {
          expandedLevels.delete(level);
        }
      },

      togglePath: (path, level, isDirectSelection = true, isAutoSelect = false) => {
        if (expandedPaths.has(path)) {
          expandedPaths.delete(path);
          directlySelectedPaths.delete(path);
          if (expandedLevels.get(level) === path) {
            expandedLevels.delete(level);
          }
          if (isAutoSelect) {
            directlySelectedPaths.add(path);
          }
          return false;
        }
        if (expandedLevels.has(level)) {
          const previousPath = expandedLevels.get(level);
          if (previousPath !== path) {
            expandedPaths.delete(previousPath);
            directlySelectedPaths.delete(previousPath);
          }
        }
        // For auto-select, we want to keep it collapsed
        if (!isAutoSelect) {
          expandedPaths.add(path);
          expandedLevels.set(level, path);
        } else {
          expandedPaths.delete(path);
          expandedLevels.delete(level);
        }
        if (isDirectSelection) {
          directlySelectedPaths.add(path);
        }
        return !isAutoSelect; // Return false for auto-select to keep it collapsed
      },
      clear: () => {
        expandedPaths.clear();
        expandedLevels.clear();
        directlySelectedPaths.clear();
      },
    };
  };

  // Add this helper function to get all siblings including self
  // const getSiblingsAndSelf = (items, path) => {
  //   const segments = path.split('/');
  //   segments.pop(); // Remove last segment to get parent path
  //   const parentPath = segments.join('/');
  //
  //   return items.filter(item => {
  //     const itemPath = cleanCategoryValue(item.value);
  //     const itemSegments = itemPath.split('/');
  //     itemSegments.pop();
  //     const itemParentPath = itemSegments.join('/');
  //     return itemParentPath === parentPath;
  //   });
  // };

  // Add this helper function to check if item is a child of path
  const isChildOf = (childPath, parentPath) => {
    const childSegments = childPath.split("/");
    const parentSegments = parentPath.split("/");
    if (childSegments.length !== parentSegments.length + 1) return false;

    for (let i = 0; i < parentSegments.length; i += 1) {
      if (parentSegments[i] !== childSegments[i]) return false;
    }
    return true;
  };
  // const expandedState = createExpandedStateManager();
  const renderHierarchicalMenu = (renderOptions, isFirstRender) => {
    const { items, refine, widgetParams } = renderOptions;

    const containerElem =
      typeof widgetParams.container === "string"
        ? document.querySelector(widgetParams.container)
        : widgetParams.container;

    if (!containerElem) {
      // Container not found for hierarchical menu
      return;
    }

    // Check if we're on the search page
    const isSearchPage = window.location.pathname.includes("/search");

    // Initialize or get expanded state manager
    if (!containerElem._expandedState) {
      containerElem._expandedState = createExpandedStateManager();
    }
    const expandedState = containerElem._expandedState;

    // Handle URL changes through InstantSearch's dispose
    if (!containerElem._dispose) {
      containerElem._dispose = () => {
        // resetMenu();
      };
    }

    // Build hierarchical structure
    const hierarchy = buildHierarchy(items);
    // Always reset on each render if URL has changed
    const currentUrl = window.location.href;
    if (containerElem._lastUrl && containerElem._lastUrl !== currentUrl) {
      // resetMenu();
    }
    containerElem._lastUrl = currentUrl;

    // Now that expandedState exists, check for initial active paths
    if (
      !hasLoggedInitialPaths &&
      items &&
      items.length > 0 &&
      (isHierarchicalMenuFirstElementClicked === false || isSearchPage)
    ) {
      const activePaths = items.filter((item) => item.isRefined).map((item) => cleanCategoryValue(item.value));
      // Only proceed if we have active paths (pre-existing filters)
      if (activePaths.length > 0) {
        // Check if we're loading the page with filters
        const urlParams = new URLSearchParams(window.location.search);
        const hasInitialCategories = urlParams.has("categories");

        if (hasInitialCategories) {
          // let activeLevel;
          const level1Paths = activePaths.map((path) => path.split("/").slice(0, 2).join("/"));
          const uniqueLevel1Paths = [...new Set(level1Paths)];
          if (activePaths.length === 1) {
            // activeLevel = 2;
            const level1Path = activePaths[0].split("/").slice(0, 2).join("/");
            const level0path = activePaths[0].split("/").slice(0, 1).join("/");
            const levelpath = activePaths[0].split("/").slice(0, 3).join("/");

            expandedState.togglePath(level0path, 0, true);
            expandedState.togglePath(level1Path, 1, true);
            expandedState.togglePath(levelpath, 2, true);
            // isInitializing = false;
          } else if (uniqueLevel1Paths.length === 1) {
            // activeLevel = 1;
            const level0Path = activePaths[0].split("/")[0];
            const level1Path = uniqueLevel1Paths[0];

            // isInitializing = true;
            expandedState.togglePath(level0Path, 0, true);
            expandedState.togglePath(level1Path, 1, true);
            // isInitializing = false;
          } else {
            // activeLevel = 0;
            const firstPath = activePaths[0];
            const level0Path = firstPath.split("/")[0];
            expandedState.togglePath(level0Path, 0, true);
          }
        }
        hasLoggedInitialPaths = true;
      }
    }

    // Function to render a single level of the hierarchy
    const renderLevel = (node) => {
      const segments = node.path.split("/");
      const currentSegment = segments[segments.length - 1];
      const level = segments.length - 1;
      let indentStyle = "";
      if (level === 1) {
        indentStyle = "padding-left: var(--space--x-sm);padding-top: 8px;";
      } else if (level > 1) {
        indentStyle = "padding-left: calc(var(--space--x-sm) * 3);padding-top: 8px;";
      }

      // Add appropriate classes based on refinement state
      const activeClasses = [];
      const isDirectlySelected = expandedState.isDirectlySelected(node.path);

      // Add active class if directly selected or if it's a parent of a selected item
      if (isDirectlySelected || (node.isRefined && expandedState.isExpanded(node.path))) {
        activeClasses.push("filter-checkboxes__item--active");
        activeClasses.push("filter-checkboxes__item--highlighted");
      }

      // Check if this node should be expanded
      const isExpanded = expandedState.isExpanded(node.path);
      if (isExpanded) activeClasses.push("filter-checkboxes__item--expanded");

      const children = Object.values(node.children);
      const hasChildren = children.length > 0;

      // Check if this node or any of its children are refined
      const isNodeRefined = items.some((item) => {
        const itemPath = cleanCategoryValue(item.value);
        return (itemPath === node.path || itemPath.startsWith(`${node.path}/`)) && item.isRefined;
      });

      return `
        <div class="field field--row filter-checkboxes__input filter-checkboxes__clickable-item ${activeClasses.join(" ")}" 
             style="${indentStyle} cursor: pointer;" 
             data-path="${node.path}" 
             data-has-children="${hasChildren}"
             data-refined="${isNodeRefined}"
             data-level="${level}">
          <div class="filter-checkboxes__content" style="flex: 1; min-width: 0;">
            <span class="text" style="--text-color: ${activeClasses.includes("filter-checkboxes__item--highlighted") ? "var(--color--secondary)" : "var(--text-color--default)"}; hyphens: auto; word-wrap: break-word; overflow-wrap: break-word; white-space: normal; line-height: 1.2; display: block;">
              ${currentSegment}
            </span>
          </div>
          <span class="filter-checkboxes__count-option text--secondary text--copy-medium-default" style="flex-shrink: 0; padding-left: 8px;">
            ${node.count}
          </span>
        </div>
        ${
          hasChildren
            ? `
          <div class="filter-checkboxes__children" style="display: ${isExpanded ? "block" : "none"};">
            ${children.map((child) => renderLevel(child)).join("")}
          </div>
        `
            : ""
        }
      `;
    };

    // Initialize container on first render
    if (isFirstRender) {
      // Add CSS styles for active states if not already added
      if (!document.querySelector("#hierarchical-menu-styles")) {
        const style = document.createElement("style");
        style.id = "hierarchical-menu-styles";
        style.textContent = `
          .filter-checkboxes__item--active {
            font-weight: bold;
          }
          .filter-checkboxes__item--highlighted {
            background-color: var(--color--light-grey);
          }
          .filter-checkboxes__clickable-item:hover {
            background-color: var(--color--light-grey, #f5f5f5);
          }
          .filter-checkboxes__children {
            transition: all 0.3s ease;
          }
        `;
        document.head.appendChild(style);
      }

      containerElem.innerHTML = `
        <div class="filter-dropdown-item">
          <div class="filter-dropdown-item__header">
            <span class="highlighted-text filter-dropdown-item__title" role="button">
              <span class="text text--sm text--regular text--line-height-lg text--headline-font text--none-decoration" style="--text-color: var(--color--secondary);">
                ${window.searchTranslations?.attributes?.kategorien || "Kategorien"}
              </span>
            </span>
            <svg width="16" height="16" aria-hidden="false" aria-label="Dropdown arrow" class="icon filter-dropdown-item__icon" style="--icon-fill: none; --icon-stroke: var(--color--secondary);">
              <use xlink:href="#icon-arrow-filter"></use>
            </svg>
          </div>
          <div class="filter-checkboxes filter-dropdown-item__body">
            <div class="filter-checkboxes__list"></div>
          </div>
        </div>
      `;

      // Add toggle functionality to the header
      const header = containerElem.querySelector(".filter-dropdown-item__header");
      const body = containerElem.querySelector(".filter-dropdown-item__body");
      const dropdownItem = containerElem.querySelector(".filter-dropdown-item");
      const icon = containerElem.querySelector(".filter-dropdown-item__icon");

      if (header && body && dropdownItem) {
        // Initially closed
        body.style.display = "none";
        dropdownItem.classList.add("filter-dropdown-item--closed");
        if (icon) {
          icon.style.transform = "rotate(-180deg)";
        }

        // Add click handler to toggle
        header.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          const isOpen = !dropdownItem.classList.contains("filter-dropdown-item--closed");

          if (isOpen) {
            body.style.display = "none";
            dropdownItem.classList.add("filter-dropdown-item--closed");
            dropdownItem.classList.remove("filter-dropdown-item--open");
            if (icon) {
              icon.style.transform = "rotate(-180deg)";
              icon.style.transition = "transform 0.3s ease";
            }
          } else {
            body.style.display = "";
            dropdownItem.classList.remove("filter-dropdown-item--closed");
            dropdownItem.classList.add("filter-dropdown-item--open");
            if (icon) {
              icon.style.transform = "rotate(0deg)";
              icon.style.transition = "transform 0.3s ease";
            }
          }
        });

        header.style.cursor = "pointer";
      }
    }

    const listContainer = containerElem.querySelector(".filter-checkboxes__list");
    if (!listContainer) return;
    // Render the hierarchical menu
    listContainer.innerHTML = Object.values(hierarchy)
      .map((node) => renderLevel(node))
      .join("");

    // Add click handlers
    const clickableItems = listContainer.querySelectorAll(".filter-checkboxes__clickable-item");
    clickableItems.forEach((clickableItem) => {
      clickableItem.addEventListener("click", async (e) => {
        e.stopPropagation();

        const path = clickableItem.getAttribute("data-path");
        const hasChildren = clickableItem.getAttribute("data-has-children") === "true";
        const isRefinedFromAttr = clickableItem.getAttribute("data-refined") === "true";
        const isRefinedFromItems = items.some((item) => cleanCategoryValue(item.value) === path && item.isRefined);
        const isRefined = isRefinedFromAttr || isRefinedFromItems;
        const level = parseInt(clickableItem.getAttribute("data-level"), 10);
        const isDirectlySelected = expandedState.isDirectlySelected(path);

        // Handle deselection for level 0 - clear all filters
        if (isRefined && isDirectlySelected && level === 0) {
          expandedState.clear();
          // Clear all refinements in the hierarchical menu
          const refinedItems = items.filter((item) => item.isRefined);
          refinedItems.forEach((item) => refine(item.value));
          return;
        }

        // Handle deselection for any level above 0
        if (isRefined && isDirectlySelected && level > 0) {
          // Remove bold from current item
          // clickableItem.classList.remove('filter-checkboxes__item--active');
          expandedState.togglePath(path, level, false);

          // Find and select parent
          const parentPath = path.split("/").slice(0, -1).join("/");
          const parentElement = listContainer.querySelector(`[data-path="${parentPath}"]`);

          if (parentElement) {
            // Instead of just refining the parent, we need to refine it and its children
            const parentDataPath = parentElement.getAttribute("data-path");
            const parentLevel = parseInt(parentElement.getAttribute("data-level"), 10);

            // First, clear all existing refinements
            const refinedItems = items.filter((item) => item.isRefined);
            refinedItems.forEach((item) => refine(item.value));

            // Get all items that should be refined based on the hierarchy
            const itemsToRefine =
              parentLevel === 0
                ? getAllChildPaths(items, parentDataPath) // For level 0, get all descendants
                : items.filter((item) => {
                    // For level 1, get only direct children
                    const itemPath = cleanCategoryValue(item.value);
                    return itemPath === parentDataPath || isChildOf(itemPath, parentDataPath);
                  });

            // expandedState.togglePath(parentDataPath, level - 1, true, true);

            // Update isRefined in the items array - set to true for parent and its children
            items.forEach((item) => {
              const itemPath = cleanCategoryValue(item.value);
              // Set isRefined to true for items that should be refined
              Object.assign(item, {
                isRefined: itemsToRefine.some((refinedItem) => cleanCategoryValue(refinedItem.value) === itemPath),
              });
            });
            // Apply refinements to parent and its children
            itemsToRefine.forEach((item) => refine(item.value));

            return;
          }
        }

        const refinedItems = items.filter((item) => item.isRefined);
        refinedItems.forEach((item) => refine(item.value));

        // Then apply the new selection based on what was clicked
        if (level === 0) {
          // Make item bold and expand
          expandedState.togglePath(path, level, true);

          // Show children if any
          if (hasChildren) {
            const childrenContainer = clickableItem.nextElementSibling;
            if (childrenContainer && childrenContainer.classList.contains("filter-checkboxes__children")) {
              childrenContainer.style.display = "block";
            }
          }

          // Get all items that should be refined based on the hierarchy
          const itemsToRefine = getAllChildPaths(items, path);

          // Update isRefined in the items array
          items.forEach((item) => {
            const itemPath = cleanCategoryValue(item.value);
            Object.assign(item, {
              isRefined: itemsToRefine.some((refinedItem) => cleanCategoryValue(refinedItem.value) === itemPath),
            });
          });

          // Apply refinements
          itemsToRefine.forEach((item) => refine(item.value));
        } else if (level === 1) {
          // Make item bold and expand
          expandedState.togglePath(path, level, true);
          // Show children if any
          if (hasChildren) {
            const childrenContainer = clickableItem.nextElementSibling;
            if (childrenContainer && childrenContainer.classList.contains("filter-checkboxes__children")) {
              childrenContainer.style.display = "block";
            }
          }

          // Get all direct children and the item itself
          const itemsToRefine = items.filter((item) => {
            const itemPath = cleanCategoryValue(item.value);
            return itemPath === path || isChildOf(itemPath, path);
          });

          // Update isRefined in the items array
          items.forEach((item) => {
            const itemPath = cleanCategoryValue(item.value);
            Object.assign(item, {
              isRefined: itemsToRefine.some((refinedItem) => cleanCategoryValue(refinedItem.value) === itemPath),
            });
          });

          // Apply refinements
          itemsToRefine.forEach((item) => refine(item.value));
        } else {
          expandedState.togglePath(path, level, true);

          // Make item bold and remove bold from siblings
          const parentPath = path.split("/").slice(0, -1).join("/");
          const siblings = listContainer.querySelectorAll(`[data-path^="${parentPath}/"]`);

          // Filter out the current item from siblings before removing classes
          siblings.forEach((sibling) => {
            if (sibling.getAttribute("data-path") !== path) {
              sibling.classList.remove("filter-checkboxes__item--active");
            }
          });

          clickableItem.classList.add("filter-checkboxes__item--active");

          // Select only this item
          const exactMatch = items.find((item) => cleanCategoryValue(item.value) === path);
          if (exactMatch) {
            refine(exactMatch.value);
          }
        }

        scrollToFirstProduct?.();
      });
    });

    if (clickableItems.length > 0 && isHierarchicalMenuFirstElementClicked === false && !isSearchPage) {
      isHierarchicalMenuFirstElementClicked = true;
      if (new URLSearchParams(window.location.search).has("categories")) {
        return;
      }
      clickableItems.forEach((clickableItem) => {
        const itemLabel = clickableItem.querySelector(".text").textContent.trim().toLowerCase();
        const currentCollectionTitle = document
          .querySelector(".collection-header-info__title-container h1")
          ?.textContent.trim()
          .toLowerCase();
        if (itemLabel === currentCollectionTitle) {
          // from here i want to get the current path so that i can epxpand it and it's parent using the expanded state
          const currentPath = clickableItem.getAttribute("data-path");
          const currentLevel = parseInt(clickableItem.getAttribute("data-level"), 10);
          const parentPath = currentPath.split("/").slice(0, -1).join("/");

          if (currentLevel === 0) {
            expandedState.togglePath(currentPath, 0, true);
          } else if (currentLevel === 1) {
            expandedState.togglePath(currentPath, 1, true, true);
            expandedState.togglePath(parentPath, 0, true);
          } else {
            const parentOfParentPath = parentPath.split("/").slice(0, -1).join("/");
            expandedState.togglePath(parentOfParentPath, 0, true);
            expandedState.togglePath(parentPath, 1, true);
            expandedState.togglePath(currentPath, 2, true, true);
          }

          clickableItem.click();
          // clear the filters
          // Apply refinements
        }
      });
    }
  };

  /* ── attach the widget ───────────────────────────────────────────────── */
  const createHierarchicalMenuWithHeader = ({ attribute, container, limit = 10 }) => {
    const { connectRefinementList } = window.instantsearch.connectors;

    return connectRefinementList(renderHierarchicalMenu)({
      container,
      attribute,
      limit,
      operator: "or",
      sortBy: ["name:asc"],
    });
  };

  // --- renderCurrentRefinements ---
  const renderCurrentRefinements = (() => (renderOptions) => {
    const { items, refine, widgetParams } = renderOptions;
    const { container } = widgetParams;

    const containerElem = typeof container === "string" ? document.querySelector(container) : container;
    if (!containerElem) return;

    // Helper function to format attribute labels
    const formatAttributeLabel = (attribute) => {
      // Remove meta.custom.weitere_informationen prefix
      const cleanAttr = attribute.replace("meta.custom.weitere_informationen.", "");
      // Handle special cases
      const labelMap = {
        vendor: window.searchTranslations?.filters?.manufacturer || "Hersteller",
        collections: window.searchTranslations?.filters?.collections || "Kollektionen",
        price: window.searchTranslations?.filters?.price || "Preis",
        "meta.custom.express_tag": window.searchTranslations?.filters?.expressShipping || "Express Tag",
      };
      return labelMap[attribute] || cleanAttr;
    };

    // Helper function to format refinement value for display
    const formatRefinementValue = (value, attribute) => {
      // For express tag
      if (attribute === "meta.custom.express_tag" && value === "1") {
        return window.searchTranslations?.filters?.yes || "Ja";
      }

      return value;
    };

    // Helper function to check if an attribute is a grouped numeric attribute
    const isGroupedNumericAttribute = (attribute) => {
      const groupedAttributes = [
        "meta.custom.weitere_informationen.Anzahl Kochstellen",
        "meta.custom.weitere_informationen.Breite in mm",
        "meta.custom.weitere_informationen.Höhe in mm",
        "meta.custom.weitere_informationen.Kühlvolumen [Liter]",
        "meta.custom.weitere_informationen.Tiefe in mm",
      ];
      return groupedAttributes.includes(attribute);
    };

    // Helper function to find the range for a numeric value
    const findRangeForValue = (value) => {
      const numValue = Number(value);
      if (Number.isNaN(numValue)) return null;

      const rangeMin = Math.floor(numValue / 100) * 100;
      const rangeMax = rangeMin + 99;
      return `${rangeMin}-${rangeMax}`;
    };

    // Helper function to group refinements by range
    const groupRefinementsByRange = (refinements) => {
      const groups = {};
      refinements.forEach((refinement) => {
        const range = findRangeForValue(refinement.value);
        if (range) {
          if (!groups[range]) {
            groups[range] = { label: range, refinements: [] };
          }
          groups[range].refinements.push(refinement);
        }
      });
      return Object.values(groups);
    };

    let html = '<div class="active-filters">';

    // Process items simply - no complex parent/child logic
    const processedItems = [];

    items.forEach((item) => {
      // Skip item categories refinements
      if (item.attribute === "meta.custom.item_categories") {
        return;
      }

      if (item.attribute === "price" && item.refinements.length > 0) {
        // Check if we have separate min/max refinements
        const minRefinement = item.refinements.find((r) => r.operator === ">=");
        const maxRefinement = item.refinements.find((r) => r.operator === "<=");

        if (minRefinement || maxRefinement) {
          // Create a combined price item
          processedItems.push({
            attribute: item.attribute,
            refinements: [
              {
                type: "numeric",
                value: {
                  min: minRefinement ? minRefinement.value : undefined,
                  max: maxRefinement ? maxRefinement.value : undefined,
                },
                operator: "range",
                // Store original refinements for removal
                originalRefinements: item.refinements,
              },
            ],
          });
        } else {
          processedItems.push(item);
        }
      } else {
        processedItems.push(item);
      }
    });

    // Add individual filter buttons
    processedItems.forEach((item) => {
      const attributeLabel = formatAttributeLabel(item.attribute);

      // Check if this is a grouped numeric attribute
      if (isGroupedNumericAttribute(item.attribute)) {
        // Group refinements by range
        const groupedRefinements = groupRefinementsByRange(item.refinements);

        groupedRefinements.forEach((group) => {
          html += `
              <button class="active-filter" aria-label="Active filter for ${attributeLabel}: ${group.label}" type="button" data-attribute="${item.attribute}" data-range="${group.label}">
                <div class="active-filter__content">
                  <span class="text text--xx-sm text--regular text--body-font text--none-decoration active-filter__label" style="--text-color: var(--color--secondary);">
                    ${attributeLabel}:
                  </span>
                  <span class="text text--xx-sm text--bold text--body-font text--none-decoration active-filter__value" style="--text-color: var(--color--secondary);">
                    ${group.label}
                  </span>
                </div>
                <svg width="12" height="12" aria-hidden="false" aria-label="close active filter" class="active-filter__close-icon" style="--icon-fill: var(--color--secondary); --icon-stroke: none;">
                  <use xlink:href="#icon-x-close"></use>
                </svg>
              </button>
            `;
        });
      } else {
        // Handle regular refinements and price range
        item.refinements.forEach((refinement) => {
          if (item.attribute === "price" && (refinement.type === "numeric" || refinement.operator === "range")) {
            const min = refinement.value.min !== undefined ? refinement.value.min : "";
            const max = refinement.value.max !== undefined ? refinement.value.max : "";
            html += `
                <button class="active-filter" aria-label="Active filter for ${attributeLabel}" type="button" data-attribute="${item.attribute}" data-is-price-range="true">
                  <div class="active-filter__content">
                    <span class="text text--xx-sm text--regular text--body-font text--none-decoration active-filter__label" style="--text-color: var(--color--secondary);">
                      ${attributeLabel}:
                    </span>
                    <span class="text text--xx-sm text--bold text--body-font text--none-decoration active-filter__value" style="--text-color: var(--color--secondary);">
                      ${min}${window.algoliaConfig?.currency || "€"} - ${max}${window.algoliaConfig?.currency || "€"}
                    </span>
                  </div>
                  <svg width="12" height="12" aria-hidden="false" aria-label="close active filter" class="active-filter__close-icon" style="--icon-fill: var(--color--secondary); --icon-stroke: none;">
                    <use xlink:href="#icon-x-close"></use>
                  </svg>
                </button>
              `;
          } else {
            // Format the refinement value based on attribute type
            const displayValue = formatRefinementValue(refinement.label || refinement.value, item.attribute);

            html += `
                <button class="active-filter" aria-label="Active filter for ${attributeLabel}: ${displayValue}" type="button" data-attribute="${item.attribute}" data-refinement-value="${refinement.value}">
                  <div class="active-filter__content">
                    <span class="text text--xx-sm text--regular text--body-font text--none-decoration active-filter__label" style="--text-color: var(--color--secondary);">
                      ${attributeLabel}:
                    </span>
                    <span class="text text--xx-sm text--bold text--body-font text--none-decoration active-filter__value" style="--text-color: var(--color--secondary);">
                      ${displayValue}
                    </span>
                  </div>
                  <svg width="12" height="12" aria-hidden="false" aria-label="close active filter" class="active-filter__close-icon" style="--icon-fill: var(--color--secondary); --icon-stroke: none;">
                    <use xlink:href="#icon-x-close"></use>
                  </svg>
                </button>
              `;
          }
        });
      }
    });

    // Add reset button if there are active filters
    if (processedItems.length > 0) {
      html += `
          <button class="button button__secondary-outline button__size--md js-reset-filters" aria-label="remove all filters" type="button">
            <span class="button__label">${window.searchTranslations?.filters?.resetAll || "Alle zurücksetzen"}</span>
          </button>
        `;
    }

    html += "</div>";

    // Update container
    containerElem.innerHTML = html;

    // Add click handlers for individual filter removal
    containerElem.querySelectorAll(".active-filter").forEach((button) => {
      button.addEventListener("click", () => {
        const attribute = button.getAttribute("data-attribute");
        const range = button.getAttribute("data-range");
        const isPriceRange = button.getAttribute("data-is-price-range") === "true";
        const refinementValue = button.getAttribute("data-refinement-value");

        // Find the item for this attribute
        const item = items.find((i) => i.attribute === attribute);
        if (!item) return;

        if (range && isGroupedNumericAttribute(attribute)) {
          // For grouped filters, remove all refinements in the range
          const groupedRefinements = groupRefinementsByRange(item.refinements);
          const group = groupedRefinements.find((g) => g.label === range);

          if (group) {
            group.refinements.forEach((refinement) => {
              refine(refinement);
            });
          }
        } else if (isPriceRange) {
          // For price ranges, remove all price refinements
          item.refinements.forEach((refinement) => {
            refine(refinement);
          });
        } else {
          // For regular filters, find and remove the specific refinement
          const refinement = item.refinements.find((r) => r.value === refinementValue);
          if (refinement) {
            refine(refinement);
          }
        }

        scrollToFirstProduct?.();
      });
    });

    // Add reset all filters handler
    const resetButton = containerElem.querySelector(".js-reset-filters");
    if (resetButton) {
      resetButton.addEventListener("click", () => {
        // Remove all refinements
        items.forEach((item) => {
          item.refinements.forEach((refinement) => {
            refine(refinement);
          });
        });
        scrollToFirstProduct?.();
      });
    }
  })();

  const openFirstFiveFacets = () => {
    const facetsContainer = document.querySelector("#facets");

    if (!facetsContainer) {
      setTimeout(openFirstFiveFacets, 100);
      return;
    }

    const openFacets = () => {
      const facets = facetsContainer.querySelectorAll(".filter-dropdown-item");

      let openedCount = 0;
      facets.forEach((facet) => {
        const body = facet.querySelector(".filter-dropdown-item__body");
        const icon = facet.querySelector(".filter-dropdown-item__icon");
        if (openedCount < 5) {
          if (body.style.display === "none") {
            // eslint-disable-next-line no-param-reassign
            facet.style.display = "";
            facet.classList.remove("filter-dropdown-item--closed");
            facet.classList.add("filter-dropdown-item--open");
            body.style.display = "";
            if (icon) {
              icon.style.transform = "rotate(0deg)";
            }
          }
          openedCount += 1;
        }
      });
    };

    const observer = new MutationObserver(() => {
      const facets = facetsContainer.querySelectorAll(".filter-dropdown-item");
      if (facets.length > 0) {
        observer.disconnect();
        setTimeout(openFacets, 200);
      }
    });

    observer.observe(facetsContainer, {
      childList: true,
      subtree: true,
    });

    const existingFacets = facetsContainer.querySelectorAll(".filter-dropdown-item");
    if (existingFacets.length > 0) {
      observer.disconnect();
      setTimeout(openFacets, 200);
    }
  };

  // --- renderPagination ---
  const renderPagination = (() => (renderOptions) => {
    const { currentRefinement, nbPages, isFirstPage, isLastPage, refine, createURL, widgetParams } = renderOptions;
    const { container } = widgetParams;

    const containerElem = typeof container === "string" ? document.querySelector(container) : container;
    if (!containerElem) {
      // Pagination container not found
      return;
    }

    // Don't show pagination if there's only one page
    if (nbPages <= 1) {
      containerElem.innerHTML = "";
      return;
    }

    let html = '<div class="pagination" role="navigation" aria-label="Pagination">';

    // Previous button
    if (!isFirstPage) {
      html += `<a href="${createURL(currentRefinement - 1)}" class="button button__secondary-outline button__size--md pagination__prev" aria-label="Go to previous page">
          <svg aria-hidden="false" class="button__icon" style="stroke: rgb(0, 35, 65); fill: none;">
            <use href="#icon-arrow-pagination-right"></use>
          </svg>
        </a>`;
    }
    // Page numbers
    const maxVisiblePages = 5;
    let startPage = Math.max(0, currentRefinement - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(nbPages - 1, startPage + maxVisiblePages - 1);

    // Adjust start if we're near the end
    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    // First page
    if (startPage > 0) {
      html += `<a href="${createURL(0)}" class="pagination-item${currentRefinement === 0 ? " pagination-item--active" : ""}" aria-label="${currentRefinement === 0 ? "Current page, page 1" : "Go to page 1"}"${currentRefinement === 0 ? ' aria-current="page"' : ""}>
        <span class="text text--xx-sm text--bold text--body-font text--none-decoration pagination-item__number" style="--text-color: var(--color--secondary);">
          1
        </span>
      </a>`;

      if (startPage > 1) {
        html += `<a role="link" aria-disabled="true" class="pagination-item" aria-current="page" aria-label="Current page, page …">
          <span class="text text--xx-sm text--bold text--body-font text--none-decoration pagination-item__number" style="--text-color: var(--color--secondary);">
            …
          </span>
        </a>`;
      }
    }

    // Visible page numbers
    for (let i = startPage; i <= endPage; i += 1) {
      const pageNumber = i + 1;
      const isActive = i === currentRefinement;

      if (isActive) {
        html += `<a role="link" aria-disabled="true" class="pagination-item pagination-item--active" aria-current="page" aria-label="Current page, page ${pageNumber}">
          <span class="text text--xx-sm text--bold text--body-font text--none-decoration pagination-item__number" style="--text-color: var(--color--secondary);">
            ${pageNumber}
          </span>
        </a>`;
      } else {
        html += `<a href="${createURL(i)}" class="pagination-item" aria-label="Go to page ${pageNumber}">
          <span class="text text--xx-sm text--bold text--body-font text--none-decoration pagination-item__number" style="--text-color: var(--color--secondary);">
            ${pageNumber}
          </span>
        </a>`;
      }
    }

    // Last page
    if (endPage < nbPages - 1) {
      if (endPage < nbPages - 2) {
        html += `<a role="link" aria-disabled="true" class="pagination-item" aria-current="page" aria-label="Current page, page …">
          <span class="text text--xx-sm text--bold text--body-font text--none-decoration pagination-item__number" style="--text-color: var(--color--secondary);">
            …
          </span>
        </a>`;
      }

      html += `<a href="${createURL(nbPages - 1)}" class="pagination-item${currentRefinement === nbPages - 1 ? " pagination-item--active" : ""}" aria-label="${currentRefinement === nbPages - 1 ? `Current page, page ${nbPages}` : `Go to page ${nbPages}`}"${currentRefinement === nbPages - 1 ? ' aria-current="page"' : ""}>
        <span class="text text--xx-sm text--bold text--body-font text--none-decoration pagination-item__number" style="--text-color: var(--color--secondary);">
          ${nbPages}
        </span>
      </a>`;
    }

    // Next button
    if (!isLastPage) {
      html += `<a href="${createURL(currentRefinement + 1)}" class="button button__secondary-outline button__size--md pagination__next" aria-label="Go to next page">
        <svg aria-hidden="false" class="button__icon" style="stroke: rgb(0, 35, 65); fill: none;">
          <use href="#icon-arrow-pagination-right"></use>
        </svg>
      </a>`;
    }

    html += "</div>";

    containerElem.innerHTML = html;

    // Add click handlers
    containerElem.querySelectorAll("a[href]").forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const href = link.getAttribute("href");
        const url = new URL(href, window.location.href);
        const urlParams = new URLSearchParams(url.search);

        // Extract page number from URL
        let pageNumber = 0;
        if (urlParams.has("page")) {
          pageNumber = parseInt(urlParams.get("page"), 10) - 1;
        }

        // Algolia uses 0-based indexing
        refine(pageNumber);

        // Scroll to top of results
        const resultsContainer = document.querySelector("#hits");
        if (resultsContainer) {
          resultsContainer.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });
  })();

  // --- renderStats ---
  const renderStats = (() => {
    let isInitialLoad = true;

    return (renderOptions) => {
      const { nbHits } = renderOptions;

      // Hide/show filters based on whether there are results
      const filterSelectors = [
        "#facets",
        "#facets-mobile",
        ".filter-drawer",
        ".filter-sorting-button",
        "#current-refinements",
        "#sorting",
        "#sorting-mobile",
        ".filter-header",
        ".filter-sorting-btn",
      ];

      // Elements that should not be hidden during initial load to prevent CLS
      const preventInitialHide = [".filter-header"];

      // Only prevent hiding facets on desktop where they're visible
      if (window.innerWidth >= 1024) {
        preventInitialHide.push("#facets");
      }

      filterSelectors.forEach((selector) => {
        const element = document.querySelector(selector);
        if (element) {
          // Don't hide certain elements on initial load to prevent CLS
          if (preventInitialHide.includes(selector) && isInitialLoad) {
            // Keep these elements visible during initial load
            return;
          }

          if (nbHits === 0) {
            element.setAttribute("style", "display: none;");
          } else {
            element.removeAttribute("style");
          }
        }
      });

      // After first render, allow normal hide/show behavior
      if (isInitialLoad) {
        isInitialLoad = false;
      }

      // Update all filter drawer footer buttons with the current results count
      const footerButtons = document.querySelectorAll(".filter-drawer__footer-btn .button__label");

      footerButtons.forEach((buttonElement) => {
        // Find the results count span within the button
        const countSpan = buttonElement.querySelector(".js-results-count");
        if (countSpan) {
          // eslint-disable-next-line no-param-reassign
          countSpan.textContent = nbHits;
        } else {
          // Fallback for old structure - get the translation text and update
          const displayText = buttonElement.textContent.split(" ").slice(1).join(" ").trim();
          // eslint-disable-next-line no-param-reassign
          buttonElement.textContent = `${nbHits} ${displayText}`;
        }
      });

      // Also update the search header results count if it exists
      const searchResultsCount = document.querySelector(".search-header__results-count");
      if (searchResultsCount) {
        // Extract the translation format and update with new count
        const currentText = searchResultsCount.textContent;
        const match = currentText.match(/\((.*?)\)/);
        if (match) {
          const template = match[1];
          // Replace the number in the template
          const newText = template.replace(/\d+/, nbHits);
          searchResultsCount.textContent = `( ${newText} )`;
        }
      }
    };
  })();

  // Helper function to format value for refinement
  // const formatForRefinement = (value) => `["${value}"]`;

  Object.assign(ns, {
    renderRangeSlider,
    renderSortBy,
    createRefinementListWithHeader,
    createGroupedNumericRefinementList,
    createExpressTagRefinement,
    createHierarchicalMenuWithHeader,
    renderCurrentRefinements,
    openFirstFiveFacets,
    renderPagination,
    initializeFilterButtons,
    renderStats,
  });
})((window.ProductSearch = window.ProductSearch || {}));
